import { getLocaleStore } from '@/i18n/index';
import { type ListStyle } from '@/version-types';

// 列表符号
export const LIST_CHAR_ALL = '1234567890abcdefghijklIVX.•●○■'; // 26个字母省略后面的几个 mnopqrstuvwxyz

// 占位符的大小
export const LIST_STYLE_SPACE = 1.3;

export const LIST_STYLE_SPACE_MAX = 1.8;

export const LIST_MARKER_DICT = {
    'lower-latin': 'abcdefghijklmnopqrstuvwxyz',
    'upper-roman': 'ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ',
    disc: '●',
    circle: '○',
    square: '■',
};

export const NORMAL_LIST_STYLES: Record<Exclude<ListStyle, '' | 'custom'>, string> = {
    decimal: `1. 2. 3.`,
    'lower-latin': `a. b. c.`,
    'upper-roman': `Ⅰ. Ⅱ. Ⅲ.`,
    disc: `● ● ●`,
    circle: `○ ○ ○`,
    square: `■ ■ ■`,
};

export const LIST_STYLE_TITLE = () => {
    const { $t } = getLocaleStore();
    return {
        unordered: $t((v) => v.textLayer.unorderList),
        ordered: $t((v) => v.textLayer.orderList),
    };
};

export const LIST_MARKER_SIZE_RANGE = {
    min: 0.6,
    max: 1.3,
    step: 0.1,
};
